import { Component, inject, input } from '@angular/core';
import { MuiList } from './mui-list.component';


@Component({
  selector: 'mui-list-header',
  template: `
    <div class="mui-list-header__title" [id]="parent.id() + '_title'">
      {{ label() }}
    </div>
    <div class="mui-list-header__actions">
      <ng-content></ng-content>
    </div>
  `,
  styleUrl: './mui-list-header.component.scss'
})
export class MuiListHeader {
  readonly label = input<string>();
  protected readonly parent = inject(MuiList);
}

